/**
 * Shared service-type matchers — plan 81 / plan 84.
 *
 * Plan 84 supersedes the two-service Parent/Child architecture with a
 * single Parent/Child Session card carrying a 1–4 child quantity
 * selector. The legacy Additional Child detector and `MAX_ADDITIONAL_CHILDREN`
 * cap exported by plan 81 are gone — every layer that needs to know
 * "how many children" now reads `CartItem.childCount` from the cart or
 * `purchases.child_count` from the persisted purchase row.
 *
 * Wire-name reference (see `src/server/db/migrator.ts`):
 *   - 'PARENT/CHILD Session'                 → base session (active)
 *   - 'PARENT/CHILD (Per Additional Child)'  → legacy add-on (is_active = FALSE)
 */
import type { Service } from '../types';

/** True for the Parent/Child Session base service (NOT the legacy add-on). */
export const isParentChildBase = (s: Pick<Service, 'name'>): boolean => {
  const upper = s.name.toUpperCase();
  return upper.includes('PARENT/CHILD') && !upper.includes('ADDITIONAL CHILD');
};
